import PropTypes from 'prop-types';

export const OECapBarPropTypes = {
    config: PropTypes.shape({
        available:              PropTypes.bool,
        showInitially:          PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        mainMenuBtn:            PropTypes.bool,
        fullscreenBtn:          PropTypes.bool
    })
};

export const OECapBarConfigFactory = {
    buildStdConfig()    {
        return {
            available:          true,
            showInitially:      true,
            mainMenuBtn:        true,
            fullscreenBtn:      true
        };
    }
};